import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronRightinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeWidth: 2,
		d: "M19.736 6.56L44.264 32 19.736 57.44",
		fill: "none",
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})
});
export default SvgChevronRightinline;
